module.exports = __webpack_public_path__ + "img/linode.759fe872.png";